"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsClientConfig_1 = __importDefault(require("../typeAssertions/valueIsClientConfig"));
const getClientConfigBuilder = (getConfigSource) => {
    const getConfig = () => {
        const config = getConfigSource();
        if (!(0, valueIsClientConfig_1.default)(config)) {
            throw new Error('INVALID CLIENT CONFIG FOUND');
        }
        return config;
    };
    const getServicesUrls = () => {
        const config = getConfig();
        return config.servicesUrls[config.environment];
    };
    const getStripeKey = () => {
        const config = getConfig();
        return config.stripeClientKeys[config.environment];
    };
    const getEnviroment = () => getConfig().environment;
    const getFirebaseWebClient = () => {
        var _a;
        const config = getConfig();
        return (_a = config.firebaseWebClient) === null || _a === void 0 ? void 0 : _a[config.environment];
    };
    const getFirebaseMessagingVapidKey = () => {
        const config = getConfig();
        return config.firebaseMessagingVapidKey[config.environment];
    };
    return {
        getServicesUrls,
        getEnviroment,
        getStripeKey,
        getFirebaseWebClient,
        getFirebaseMessagingVapidKey,
    };
};
exports.default = getClientConfigBuilder;
